import React from "react";
import { Box, Card, Skeleton, Stack, Divider } from "@mui/joy";

export const ProjectListSkeleton = () => {
    return (
        <Box flex={1} display={"flex"} flexDirection={"column"}>
            {/* Title Skeleton */}
            <Box mx={3} mt={3} display="flex" justifyContent="space-between" alignItems="center">
                <Stack spacing={1} sx={{ width: 250 }}>
                    <Skeleton variant="text" level="h2" width="60%" />
                    <Skeleton variant="text" level="body-sm" width="90%" />
                </Stack>
                <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: "md" }} />
            </Box>

            <Divider sx={{ mt: 3 }} />

            {/* Status Graph Skeleton - Segmented Bar */}
            <Box mx={2} mt={1}>
                <Card variant="plain" sx={{ p: 2, display: "flex", flexDirection: "column", gap: 2 }}>
                    <Skeleton variant="rectangular" height={10} width="100%" sx={{ borderRadius: "lg" }} />
                    <Box sx={{ display: "flex", justifyContent: "space-between", gap: 4 }}>
                        {[...Array(4)].map((_, i) => (
                            <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Skeleton variant="circular" width={8} height={8} />
                                <Skeleton variant="text" width={80} height={14} />
                                <Skeleton variant="rectangular" width={50} height={20} sx={{ borderRadius: "sm" }} />
                            </Box>
                        ))}
                    </Box>
                </Card>
            </Box>

            <Divider sx={{ mt: 0 }} />

            {/* DataGrid Skeleton - Multiple Rows matching columnDef structure */}
            <Box flex={1} mx={2} mt={2}>
                <Stack spacing={0}>
                    {[...Array(8)].map((_, i) => (
                        <Box
                            key={i}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                height: 70,
                                px: 2,
                                borderBottom: "1px solid",
                                borderColor: "divider",
                                gap: 2,
                            }}
                        >
                            {/* Project Col (flex 1.5) - No Circle here in actual UI */}
                            <Box sx={{ flex: 1.5, display: "flex", alignItems: "center" }}>
                                <Stack spacing={1} sx={{ width: "100%" }}>
                                    <Skeleton variant="text" width="70%" height={20} />
                                    <Skeleton variant="text" width="50%" height={14} />
                                </Stack>
                            </Box>

                            {/* Task Progress Col (flex 1.2) */}
                            <Box sx={{ flex: 1.2, display: "flex", flexDirection: "column", gap: 0.8 }}>
                                <Skeleton variant="text" width="80%" height={14} />
                                <Skeleton variant="rectangular" width="90%" height={8} sx={{ borderRadius: "sm" }} />
                            </Box>

                            {/* Status Col (190px) - Only Chip skeleton */}
                            <Box sx={{ width: 190, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <Skeleton variant="rectangular" width={110} height={26} sx={{ borderRadius: "6px" }} />
                            </Box>

                            {/* Customer Address Col (flex 1.5) */}
                            <Box sx={{ flex: 1.5, display: "flex", flexDirection: "column", gap: 0.5 }}>
                                <Skeleton variant="text" width="80%" height={14} />
                                <Skeleton variant="text" width="60%" height={14} />
                            </Box>

                            {/* Actions Col (170px) - Has rounded buttons */}
                            <Box sx={{ width: 170, display: "flex", alignItems: "center", gap: 1 }}>
                                <Skeleton variant="rectangular" width={55} height={32} sx={{ borderRadius: "md" }} />
                                <Skeleton variant="rectangular" width={32} height={32} sx={{ borderRadius: "md" }} />
                                <Skeleton variant="rectangular" width={32} height={32} sx={{ borderRadius: "md" }} />
                            </Box>
                        </Box>
                    ))}
                </Stack>
            </Box>
        </Box>
    );
};
